import bus from '../connection/sessionConnection';
import store from '../store';
import { updateWeights } from './sessionMonitor.action';
import {
    addBasketChange,
    addImage,
    fetchSession,
    paymentRequestChanged,
    paymentRequestCreated,
    setSessionLoading,
} from './sessionMonitorDetails.action';
import { CartImageView, cartImageViewUrl } from '@whiz-cart/node-shared/models/snapshot/cartImageView';
import { zodForgivingSchema } from '@whiz-cart/node-shared/zod/forgivingSchema';

const ForgivingCartImageView = zodForgivingSchema(CartImageView);

export default () => [
    bus.onConnection(
        () => {
            const { storeGuid, sessionGuid } = bus.config;
            if (!storeGuid || !sessionGuid) return;
            return store.dispatch(fetchSession(storeGuid, sessionGuid));
        },
        (loading) => store.dispatch(setSessionLoading(bus.config.sessionGuid ?? '', loading)),
    ),

    bus.subscribe('storeSessionBasketChanged', (item) => {
        if (typeof item !== 'object') {
            return;
        }

        // TODO: parse item
        store.dispatch(updateWeights({ ...item, sessionGuid: (item as any).basketItem.sessionGuid, t: (item as any).modifiedOn }));
        store.dispatch(addBasketChange(item as any));
    }),

    bus.subscribe('storeSessionSnapshotReceived', (item) => {
        // Forgiving rather than strict: the other end of this contract is hand-written C# in another repository, so
        // a field that drifts should reach the zod issue reporter (and Grafana) instead of taking the tile down.
        const image = ForgivingCartImageView.parse(item);

        // -safety-(claude)- Drop rather than render an image whose URL cannot be resolved. That is what an
        //                   unconfigured `CartImages:BaseUrl` on the producer looks like from here, and pushing it
        //                   through would put a permanently broken thumbnail in the session monitor.
        if (!cartImageViewUrl(image)) {
            console.error('Received a cart image with no resolvable URL', image);
            return;
        }

        store.dispatch(addImage(image));
    }),

    bus.subscribe('storeSessionPaymentRequestCreated', (item) => {
        // TODO: parse item
        store.dispatch(paymentRequestCreated(item as any));
    }),

    bus.subscribe('storeSessionPaymentRequestChanged', (item) => {
        // TODO: parse item
        store.dispatch(paymentRequestChanged(item as any));
    }),
];
